import service from '../../service/carsResource';
const initialState = {
  CardInfoVisible: false,
  CardInfo: {},
  CardInfoLoading: false,
  CardInfoError: null,
  CardInfoError: null,
  EmployeeInfoVisible: false,
  EmployeeInfo: {},
  EmployeeInfoLoading: false,
  EmployeeInfoError: null,
  VehicleInfoVisible: false,
  VehicleInfo: {},
  VehicleInfoLoading: false,
  VehicleInfoError: null,
  TransportationInfoVisible: false,
  TransportationInfo: {},
  TransportationInfoLoading: false,
  TransportationInfoError: null,
  LocationInfoVisible: false,
  LocationInfo: {},
  LocationInfoLoading: false,
  LocationInfoError: null,
  SeatInfoVisible: false,
  SeatInfo: {},
  SeatInfoLoading: false,
  SeatInfoError: null,
  BeltInfoVisible: false,
  BeltInfo: {},
  BeltInfoLoading: false,
  BeltInfoError: null,
  typeInfo: '',
  InfoBarVisible: false,
  adress: '',
  adressLoading: false,
  adressError: null,
};

export const createInfoStore = (set, get) => ({
  ...initialState,
  setCardInfoVisible: (e) => set({ CardInfoVisible: e }),
  setInfoBarVisible: (e) => set({ InfoBarVisible: e }),
  setTypeInfo: (e) => set({ typeInfo: e }),
  setCardInfo: (e) => set({ CardInfo: e }),
  setCardInfoLoading: (e) => set({ CardInfoLoading: e }),
  setCardInfoError: (e) => set({ CardInfoError: e }),
  setEmployeeInfoVisible: (e) => set({ EmployeeInfoVisible: e }),
  setEmployeeInfo: (e) => set({ EmployeeInfo: e }),
  setEmployeeInfoLoading: (e) => set({ EmployeeInfoLoading: e }),
  setEmployeeInfoError: (e) => set({ EmployeeInfoError: e }),
  setVehicleInfoVisible: (e) => set({ VehicleInfoVisible: e }),
  setVehicleInfo: (e) => set({ VehicleInfo: e }),
  setVehicleInfoLoading: (e) => set({ VehicleInfoLoading: e }),
  setVehicleInfoError: (e) => set({ VehicleInfoError: e }),
  setTransportationInfoVisible: (e) => set({ TransportationInfoVisible: e }),
  setTransportationInfo: (e) => set({ TransportationInfo: e }),
  setTransportationInfoLoading: (e) => set({ TransportationInfoLoading: e }),
  setTransportationInfoError: (e) => set({ TransportationInfoError: e }),
  setLocationInfoVisible: (e) => set({ LocationInfoVisible: e }),
  setLocationInfo: (e) => set({ LocationInfo: e }),
  setLocationInfoLoading: (e) => set({ LocationInfoLoading: e }),
  setLocationInfoError: (e) => set({ LocationInfoError: e }),
  setSeatInfoVisible: (e) => set({ SeatInfoVisible: e }),
  setSeatInfo: (e) => set({ SeatInfo: e }),
  setSeatInfoLoading: (e) => set({ SeatInfoLoading: e }),
  setSeatInfoError: (e) => set({ SeatInfoError: e }),
  setBeltInfoVisible: (e) => set({ BeltInfoVisible: e }),
  setBeltInfo: (e) => set({ BeltInfo: e }),
  setBeltInfoLoading: (e) => set({ BeltInfoLoading: e }),
  setBeltInfoError: (e) => set({ BeltInfoError: e }),
  resetInfoState: (e) => set({ ...initialState }),
  setAdress: async (e) => {
    set({ error: '' });
    try {
      set({ adressLoading: true });
      const result = await service.getLocation(e);
      set({ adress: result.data.data });
    } catch (error) {
      set({ adress: 'Adress Bulunamadı.' });
    } finally {
      set({ adressLoading: false });
    }
  },
});
